module.exports = __webpack_public_path__ + "static/services-image-1_d-e13eef25169d787c1a4447be5ef3cc2c.jpg";